var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJerm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360.36 289.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2153f;\n      }\n\n      .cls-2 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_74);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_74",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 74",
    x1: 94.29,
    y1: 127.45,
    x2: 257.15,
    y2: 68.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2153f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94857"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.41,54.75l-43.91-25.35V0l-20.41,20.41L159.85.18v29.22l-43.91,25.35c-9.77,5.64-15.78,16.06-15.78,27.34v55.94c0,11.28,6.02,21.7,15.78,27.34l48.45,27.97c9.77,5.64,21.8,5.64,31.56,0l48.45-27.97c9.77-5.64,15.78-16.06,15.78-27.34v-55.94c0-11.28-6.02-21.7-15.78-27.34ZM210.11,131.72c-7.56,7.57-16.01,14.77-29.93,26.08-13.92-11.31-22.37-18.51-29.93-26.08-16.63-16.31-15.29-31.25-15.29-31.25h0c-.01-.31-.02-.62-.02-.93,0-12.58,10.61-23.48,23.69-23.48,9.57,0,17.8,6.16,21.55,14.01h0c3.74-7.85,11.98-14.01,21.55-14.01,13.09,0,23.69,10.9,23.69,23.48,0,.31-.01.62-.02.93h0s1.34,14.94-15.29,31.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,263.38v-1.49h8.73v1.02c0,4.21,2.48,6.95,6.31,6.95,3.61,0,6.09-2.69,6.09-6.95v-26.43h8.72v26.9c0,8.66-5.94,14.81-14.82,14.81s-15.04-6.15-15.04-14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.42,261.44c0,.83-.06,1.66-.16,2.5h-23.83c.74,4.3,3.57,6.66,7.69,6.66,2.96,0,5.39-1.4,6.68-3.65h8.95c-2.29,6.87-8.32,11.24-15.63,11.24-9.3,0-16.33-7.2-16.33-16.64s6.99-16.63,16.33-16.63,16.3,7.45,16.3,16.52h0ZM44.65,258.12h15.26c-1.2-3.85-3.97-5.94-7.79-5.94s-6.48,2.21-7.47,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.38,245.64v8.03h-3.69c-4.8,0-6.69,2.13-6.69,7.27v16.36h-8.51v-31.49h6.97v3.86c2.24-2.78,5.09-4.03,9.13-4.03h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.03,245.06c6.51,0,11.09,5.11,11.09,12.49v19.75h-8.51v-18.34c0-4.2-1.65-6.42-4.73-6.42-3.8,0-6.05,2.8-6.05,7.73v17.03h-8.3v-18.34c0-4.2-1.6-6.42-4.65-6.42-3.85,0-6.15,2.8-6.15,7.73v17.03h-8.51v-31.49h5.95l1.6,3.9c2.23-2.82,5.68-4.65,9.39-4.65,4,0,7.31,1.87,9.14,5.04,2.15-3.06,5.74-5.04,9.75-5.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.87,236.48c12.01,0,20.7,8.57,20.7,20.36s-8.74,20.46-20.7,20.46h-15.44v-40.82h15.44ZM182.65,269.1c7.01,0,11.88-5.13,11.88-12.26s-4.87-12.16-11.88-12.16h-6.39v24.43h6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.76,245.76h6.36v31.49h-6.67l-.73-2.82c-2.7,2.37-6.23,3.76-10.2,3.76-9.47,0-16.52-7.15-16.52-16.68s7.05-16.59,16.52-16.59c4.04,0,7.62,1.42,10.34,3.85l.91-3.01ZM233.77,261.51c0-4.95-3.63-8.63-8.57-8.63s-8.58,3.69-8.58,8.63,3.64,8.63,8.58,8.63,8.57-3.68,8.57-8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.55,269.72v7.58h-6.05c-6.93,0-11.18-4.26-11.18-11.24v-13.4h-5.69v-6.84h5.78v-8.22h8.29v8.22h8.69v6.84h-8.55v12.27c0,3.04,1.75,4.79,4.85,4.79h3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.36,277.3v-31.49h8.51v31.49h-8.51ZM275.38,241.61v-7.91h8.48v7.91h-8.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.97,245.06c7.18,0,11.65,5.18,11.65,13.15v19.08h-8.51v-17.7c0-4.76-1.81-7.05-5.49-7.05-4.39,0-7.07,3.14-7.07,8.21v16.55h-8.51v-31.49h5.84l1.66,3.89c2.38-2.84,6.15-4.64,10.43-4.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.84,245.81h5.51v27.83c0,9.86-6.13,15.9-16.08,15.9-8.53,0-14.59-4.37-16.05-11.56h8.46c.96,2.84,4.29,4.28,7.44,4.28,4.3,0,7.88-2.78,7.88-7.39v-1.17c-2.51,1.78-5.59,2.8-9,2.8-8.8,0-15.65-6.91-15.65-15.76s6.86-15.82,15.65-15.82c4.1,0,7.75,1.5,10.46,4.02l1.37-3.13ZM352.04,260.74c0-4.68-3.33-8.11-8.02-8.11s-8.04,3.44-8.04,8.11,3.34,8.15,8.04,8.15,8.03-3.43,8.03-8.15Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.32,
    y: 233.51,
    width: 8.72,
    height: 14.68,
    transform: "translate(-221.16 260.53) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJerm);
export default __webpack_public_path__ + "static/media/jerm.1de96be24be363f076fa816a547a61eb.svg";
export { ForwardRef as ReactComponent };